import { Lubrication } from "../../pages/Lubrication";

export function MobileLubrication() {
  return <Lubrication />;
}
